// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-59a1d11d0e164aee.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 3850) return "static/chunks/3850-69678ef8a2030b20.js";
	if (chunkId === 2922) return "static/chunks/2922-9aa010d9979a0048.js";
	if (chunkId === 281) return "static/chunks/281-d024fd32064fa64d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"472":"4904ee63b045bd03","493":"403b1588f482c15c","1365":"8cd274c58b7e5545","3340":"8982fefd06ee0c94","4031":"d56d2a7854a455e1","5706":"5d4000d35a0371a4","6579":"e5a110b51467f8a0","8313":"a87f9ebae17088de","9249":"2184d43b04881543"}[chunkId] + ".js";
};